import { render, staticRenderFns } from "./PhysiciansList.vue?vue&type=template&id=513988d5&scoped=true&"
import script from "./PhysiciansList.vue?vue&type=script&lang=js&"
export * from "./PhysiciansList.vue?vue&type=script&lang=js&"
import style0 from "./PhysiciansList.vue?vue&type=style&index=0&id=513988d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513988d5",
  null
  
)

export default component.exports